<div class="am-content" style="margin-left: 120px">
  <div class="main-content lateral-layout">
    <div class="chat-main-content">
      <div class="chat-container" [class.sidebar-open]="sidebarOpen">
        <div *ngIf="(messages$ | async)?.length === 0" class="chatbot-intro">
          <h2 class="chatbot-title">Material Selection AI-Agent</h2>
          <p class="chatbot-description">
            Welcome! This is your Material Selection Virtual Assistant.<br />
            You can ask questions related to materials used in well design,
            selection criteria,<br />
            performance considerations or request support with specific
            challenges.<br />
            Type your message below to get started.
          </p>
        </div>

        <div #messagesContainer class="messages">
          <div
            *ngFor="
              let message of messages$ | async;
              let i = index;
              trackBy: trackById
            "
            [ngClass]="message.role"
            @messageAnimation
          >
            <ng-container *ngIf="message.role === 'bot'; else userMessage">
              <div
                style="display: flex; align-items: flex-start; max-width: 90%"
              >
                <img
                  src="favicon.ico"
                  title="Well Design Chat"
                  alt="Well Design Chat"
                  class="bot-avatar"
                />
                <div style="flex: 1; width: 100%">
                  <div
                    class="message-bubble"
                    [innerHTML]="message.safeContent"
                  ></div>
                  <div class="bot-actions">
                    <button title="Copy" (click)="copyMessage(message)">
                      <span
                        *ngIf="!message.copied; else copiedIcon"
                        class="s7-copy-file"
                      ></span>
                      <ng-template #copiedIcon>
                        <span class="s7-check"></span>
                      </ng-template>
                    </button>
                    <button
                      title="Appropriate response"
                      (click)="likeMessage(message)"
                      [class.selected]="message.liked"
                    >
                      <span class="s7-like2"></span>
                    </button>
                    <button
                      title="Inadequate response"
                      (click)="dislikeMessage(message)"
                      [class.selected]="message.disliked"
                    >
                      <span class="s7-like2 rotated"></span>
                    </button>
                    <button title="Listen" (click)="listenMessage(message)">
                      <span class="s7-volume"></span>
                    </button>
                    <button
                      title="Try again"
                      (click)="tryAgain(i)"
                      *ngIf="
                        !(loading$ | async) &&
                        isLastMessage('bot', i, messages$ | async)
                      "
                    >
                      <span class="s7-refresh-2"></span>
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-template #userMessage>
              <div
                style="
                  display: flex;
                  justify-content: flex-end;
                  flex-wrap: wrap;
                  max-width: 75%;
                "
              >
                <div class="message-bubble">
                  <ng-container *ngIf="editMessageIndex !== i; else editInput">
                    {{ message.content }}
                  </ng-container>
                  <ng-template #editInput>
                    <textarea
                      [(ngModel)]="editMessageText"
                      id="message-edit-input"
                      name="editMessageText"
                      class="edit-message-input auto-expand"
                      autocomplete="off"
                      autofocus
                      rows="1"
                      (input)="autoExpand($event)"
                      (keydown.enter)="acceptEditMessage()"
                    ></textarea>
                    <div class="actions-edit">
                      <button
                        (click)="acceptEditMessage()"
                        class="edit-accept-btn"
                        title="Accept"
                      >
                        Accept
                      </button>
                      <button
                        (click)="cancelEditMessage()"
                        class="edit-cancel-btn"
                        title="Cancel"
                      >
                        Cancel
                      </button>
                    </div>
                  </ng-template>
                </div>
                <div
                  class="user-actions"
                  *ngIf="
                    !(loading$ | async) &&
                    isLastMessage('user', i, messages$ | async)
                  "
                >
                  <button title="Edit message" (click)="editLastUserMessage(i)">
                    <span class="s7-pen"></span>
                  </button>
                </div>
              </div>
            </ng-template>
          </div>

          <div *ngIf="loading$ | async" class="bot">
            <div style="display: flex; align-items: flex-start">
              <img
                src="favicon.ico"
                title="Well Design Chat"
                alt="Well Design Chat"
                class="bot-avatar"
              />
              <div style="flex: 1; padding: 0.75rem 1rem">
                <div class="message-bubble">
                  <span class="typing">
                    <span></span><span></span><span></span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div style="height: 130px"></div>
        </div>
      </div>
    </div>
    <div
      class="chat-input-footer"
      [class.center-input]="(messages$ | async)?.length === 0"
      [class.sidebar-open]="sidebarOpen"
      [class.footer-sidebar-open]="sidebarOpen"
    >
      <form (ngSubmit)="sendMessage()" class="input-area">
        <textarea
          [(ngModel)]="userInput"
          id="user-message-input"
          name="userInput"
          placeholder="Type your message here..."
          required
          autocomplete="off"
          [disabled]="loading$ | async"
          rows="1"
          class="auto-expand"
          (input)="autoExpand($event)"
          (keydown.enter)="sendMessage()"
        ></textarea>
        <button
          type="submit"
          [disabled]="!(loading$ | async) && !userInput.trim()"
          *ngIf="!(loading$ | async)"
        >
          <span class="s7-paper-plane"></span>
        </button>
        <button
          type="button"
          *ngIf="loading$ | async"
          (click)="stopResponse()"
          class="stop-btn"
          title="Stop response"
        >
          <span class="s7-close"></span>
        </button>
      </form>
      <div class="legal-note">
        The Chatbot can make mistakes. Please verify important information.
      </div>
    </div>
    <button
      class="scroll-to-bottom-btn"
      title="Go to last message"
      (click)="scrollToBottom()"
      *ngIf="showScrollToBottom"
    >
      Go to last message
    </button>
    <div class="menu-btn-group right">
      <button
        class="menu-btn"
        (click)="toggleTheme()"
        aria-label="Toggle dark mode"
        [title]="darkMode ? 'Switch to light mode' : 'Switch to dark mode'"
      >
        <span [ngClass]="darkMode ? 's7-sun' : 's7-moon'"></span>
      </button>
      <button
        class="menu-btn new-chat-btn"
        [disabled]="loading$ | async"
        (click)="createNewChat()"
        aria-label="New chat"
      >
        <span class="s7-plus"></span>
      </button>
      <button
        *ngIf="selectedConversationId"
        class="menu-btn"
        (click)="downloadConversationPdf(selectedConversationId)"
        aria-label="Download conversation PDF"
        title="Download conversation PDF"
      >
        <span class="s7-bottom-arrow"></span>
      </button>
    </div>
    <div class="menu-btn-group left">
      <button
        class="menu-btn close-inside"
        (click)="toggleSidebar()"
        [attr.aria-label]="sidebarOpen ? 'Close history' : 'Open history'"
      >
        <span
          [ngClass]="sidebarOpen ? 's7-angle-right-circle' : 's7-menu'"
        ></span>
      </button>
    </div>

    <div class="sidebar-history" [class.open]="sidebarOpen">
      <div class="sidebar-header">
        <span>Chats</span>
      </div>
      <div class="history-list-wrapper">
        <div class="history-search-row">
          <input
            type="text"
            class="history-search-input"
            placeholder="Search conversations..."
            [(ngModel)]="historySearch"
            (ngModelChange)="onHistorySearchChange($event)"
            autocomplete="off"
          />

          <button
            *ngIf="historySearch"
            class="clear-search-btn"
            type="button"
            (click)="clearHistorySearch()"
            aria-label="Clear search"
          >
            <span class="s7-close"></span>
          </button>
        </div>

        <ul class="history-list" #historyList>
          <ng-container
            *ngIf="(conversations$ | async)?.length > 0; else noConversations"
          >
            <li
              *ngFor="
                let conversation of conversations$ | async;
                let idx = index
              "
              (click)="selectConversation(conversation)"
              class="conversation-item"
              [class.selected]="conversation.id === selectedConversationId"
              title="
                  Load conversation: {{ conversation.title }}
                "
              style="position: relative"
            >
              <div class="pin-title">
                <span *ngIf="conversation.pinned" class="s7-pin"></span>
                <span class="conversation-title">
                  {{ conversation.title }}
                </span>
              </div>
              <button
                type="button"
                class="menu-btn conversation-menu-btn"
                (click)="toggleConversationMenu(idx, $event)"
                aria-label="Options"
              >
                <span class="s7-more vertical-dots"></span>
              </button>
            </li>
          </ng-container>
        </ul>
        <ng-template #noConversations>
          <div class="no-conversations">No conversations found.</div>
        </ng-template>
      </div>
      <div class="sidebar-footer">
        <button
          class="comment-suggestions-btn"
          (click)="openCommentsSuggestions()"
          type="button"
        >
          <span class="s7-comment"></span>
          Comments and <br />
          suggestions
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="img-viewer-backdrop"
  *ngIf="enlargedImgUrl"
  (click)="closeImgViewer()"
>
  <img
    class="img-viewer-img"
    [src]="enlargedImgUrl"
    (click)="$event.stopPropagation()"
  />
</div>

<div
  class="conversation-menu floating"
  *ngIf="
    openConversationMenuIndex !== null &&
    (conversations$ | async) as conversations
  "
  [style.top.px]="menuPosition.top"
  [style.left.px]="menuPosition.left"
  (click)="$event.stopPropagation()"
>
  <button
    (click)="renameConversation(conversations[openConversationMenuIndex])"
  >
    <span class="s7-pen"></span>
    Rename
  </button>
  <button (click)="pinConversation(conversations[openConversationMenuIndex])">
    <span class="s7-pin pin-icon-wrapper">
      <span
        *ngIf="conversations[openConversationMenuIndex]?.pinned"
        class="pin-x"
        aria-hidden="true"
        >&#10005;</span
      >
    </span>
    {{ conversations[openConversationMenuIndex]?.pinned ? "Unpin" : "Pin" }}
  </button>
  <button
    (click)="
      downloadConversationPdf(conversations[openConversationMenuIndex]?.id)
    "
  >
    <span class="s7-bottom-arrow"></span>
    Download
  </button>
  <button
    (click)="shareConversationPdf(conversations[openConversationMenuIndex]?.id)"
  >
    <span class="s7-share"></span>
    Share
  </button>
  <button
    (click)="deleteConversation(conversations[openConversationMenuIndex])"
  >
    <span class="s7-trash"></span>
    Delete
  </button>
</div>

<app-share-conversation-modal
  #shareModal
  (onShare)="handleShareConversation($event)"
></app-share-conversation-modal>

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-clip-rotate"
  [fullScreen]="true"
  ><p style="color: white">Loading...</p></ngx-spinner
>
